export enum CardType {
  VIRTUAL = 1,
  PHYSICAL = 0,
  PRIVATE_LABEL = 3,
  PHYSICAL_NO_NAME = 4,
}

export enum CardStatus {
  CREATING = 1,
  PENDING_PASSWORD = 2,
  CREATED = 3,
  ACTIVE = 4,
  BLOCKED = 5,
  CANCELED = 6,
  ERROR_TO_CREATE = 7,
  BLOCKED_BY_ADMIN = 8,
  CANCELED_BY_ADMIN = 9,
  ERRO_TO_EMBOSSIN = 11,
}

export enum ReasonType {
  DISSATISFIED_WITH_THE_CARD = 20,
  STOLEN_CARD = 13,
  LOST_CARD = 14,
  MISGUIDED_CARD = 15,
  CANCELED_AT_CUSTOMER_REQUEST = 21,
  CANCELED_AT_ADM_REQUEST = 22,
  INFREQUENT_USE = 23,
  CUSTOMER_SERVICE_ISSUES = 24,
  SECURITY_OR_FRAUD_ISSUES = 25,
}

export enum PermissionsCardType {
  ALL = 0,
  TRANSFER = 1,
  PIX = 2,
  CARDS = 3,
  PROFILE = 4,
  PAYABLE = 5,
  RECEIVABLE = 6,
  PAYSLIP = 7,
  EMPLOYEES = 8,
  TED = 9,
  P2P = 10,
  BILLET = 11,
}

export enum CardFunction {
  CREDIT = 1,
  DEBIT = 2,
  MULTIPLE = 3,
}

export enum CardStatusDock {
  NORMAL = 1,
  BLOCKED = 2,
  CANCELED = 3,
  MIGRATED = 18,
  MIGRATED_BLOCKED = 25,
  REISSUED = 27,
  CANCELED_DEFINITIVE_REISSUED = 28,
  LOCKED_INCORRECT_PASSWORD = 29,
  CANCELED_NO_CVV = 30,
  SUSPECTED_FRAUD = 32,
  BLOCKED_PREVENTIVE = 37,
  MONEY_LAUNDERING_PREVENTION = 171,
}

export enum CardStage {
  CREATED = 1,
  SENT_TO_EMBOSSING = 2,
  RECEIVED = 3,
  FORWARDED = 4,
  UNBLOCKED_WITH_CODE = 5,
  UNBLOCKED_WITHOUT_CODE = 6,
  UNBLOCKED_INFORMATION = 7,
  REVIEWED = 8,
  TO_BE_COLLETED = 9,
  COLLECTED = 10,
  MISPLACED = 11,
  EMBOSSING_PREVIEW = 12,
  PREVIEW = 13,
  EMBOSSING_INCONSISTENT = 14,
  EMBOSSING_INCONSISTENCY = 15,
  EMBOSSING = 15,
}

export enum CardFirstAccessStatus {
  PENDING = 1,
  COMPLETED = 2,
  NOT_APPLICABLE = 3,
}

export enum CardControlEnum {
  CONTACTLESS = 'CONTACTLESS',
  INTERNATIONAL = 'INTERNATIONAL',
}

export enum AccountDockSolicitationStatus {
  PENDING = 1,
  COMPLETED = 2,
  FAILED = 3,
}

export enum CardsKeySettingsEnum {
  CARD_CONTACT_EMAIL = 'CARD_CONTACT_EMAIL',
  CARD_PHONE_NUMBER = 'CARD_PHONE_NUMBER',
  CARD_WHATSAPP_NUMBER = 'CARD_WHATSAPP_NUMBER',
}

export enum CardMilestone {
  CARD_REQUESTED = 'CARD_REQUESTED',
  SENT_TO_EMBOSSING = 'SENT_TO_EMBOSSING',
  FORWARDED_TO_CARRIER = 'FORWARDED_TO_CARRIER',
  CARD_DELIVERED = 'CARD_DELIVERED',
}

export enum CardMilestoneSource {
  INTERNAL = 'INTERNAL',
  DOCK = 'DOCK',
  USER = 'USER',
  CARRIER = 'CARRIER',
}

export enum CardMilestoneStatus {
  COMPLETED = 'completed',
  PENDING = 'pending',
  PROCESSING = 'processing',
}
